import { ViewportPortal } from '@xyflow/react';
import React from 'react';
import ReactDOM from 'react-dom';

import { useBuilderStateContext } from '../../builder-hooks';
import { flowUtilConsts } from '../utils/consts';

import FlowEndWidget from '@/app/builder/flow-canvas/widgets/flow-end-widget';
import IncompleteSettingsButton from '@/app/builder/flow-canvas/widgets/incomplete-settings-widget';
import { TestFlowWidget } from '@/app/builder/flow-canvas/widgets/test-flow-widget';
import ViewOnlyWidget from '@/app/builder/flow-canvas/widgets/view-only-widget';

const AboveFlowWidgets = React.memo(() => {
  const [flowVersion, setRun, selectStepByName, readonly] =
    useBuilderStateContext((state) => [
      state.flowVersion,
      state.setRun,
      state.selectStepByName,
      state.readonly,
    ]);

  return ReactDOM.createPortal(
    <div className="fixed top-[10%] left-1/2 transform -translate-x-1/2 z-[1000] pointer-events-auto">
      <div className="flex justify-center items-center w-[260px]">
        {!readonly ? (
          <>
            <TestFlowWidget flowVersion={flowVersion} setRun={setRun} />
            <IncompleteSettingsButton
              flowVersion={flowVersion}
              selectStepByName={selectStepByName}
            />
          </>
        ) : (
          <ViewOnlyWidget />
        )}
      </div>
    </div>,
    document.body,
  );
});
AboveFlowWidgets.displayName = 'AboveFlowWidgets';

export { AboveFlowWidgets };
